import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Connects to data-controller="party-links-modal"
export default class extends Controller {
    connect() {
        // Create and show the Bootstrap modal when the controller connects
        this.modal = new Modal(this.element);
        this.modal.show();
    }

    disconnect() {
        if (this.modal) {
            this.modal.hide();
            this.modal = null;
        }
    }
}